export default {_name:'mobile.logo',module:'Field',view:'Element/Image/MobileLogo',options:{key:'mobileLogo',config:'ui/image/mobilelogo'}}